import { createPlugin } from '@backstage/core-plugin-api';

/**
 * Developer feedback plugin: a floating button on every page that opens a
 * form whose contents go straight to the platform team's Teams channel.
 *
 * The plugin has no page, so nothing in the app tree mounts it; its API
 * client is therefore registered by the app itself in
 * `packages/app/src/apis.ts` rather than declared here.
 */
export const feedbackPlugin = createPlugin({
  id: 'feedback',
});
